var render = function () {
  var _vm$settings$detailLi, _vm$settings$detailLi2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "t-bounds"
  }, [_c('div', {
    staticClass: "t-panel-section"
  }, [_c('div', {
    staticClass: "t-panel-heading"
  }, [_vm.heading ? _c('div', [_vm._v(" " + _vm._s(_vm.heading) + " ")]) : ((_vm$settings$detailLi = _vm.settings.detailLink) !== null && _vm$settings$detailLi !== void 0 ? _vm$settings$detailLi : _vm.pubInfo.detailUrl) ? _c('a', {
    attrs: {
      "href": (_vm$settings$detailLi2 = _vm.settings.detailLink) !== null && _vm$settings$detailLi2 !== void 0 ? _vm$settings$detailLi2 : _vm.pubInfo.detailUrl
    }
  }, [_vm._v(" " + _vm._s(_vm.pubInfo.title) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.pubInfo.title) + " ")])])]), !_vm.attachmentsList || !_vm.attachmentsList.length ? _c('div', {
    staticClass: "t-panel-section"
  }, [_c('p', [_vm._v("There are no attachments available on this page.")])]) : _vm._l(_vm.attachmentsList, function (al, ali) {
    return _c('div', {
      key: ali,
      staticClass: "t-panel-section"
    }, [_c('div', {
      staticClass: "t-panel-subheading"
    }, [_vm._v(_vm._s(al.heading))]), _c('ul', {
      staticClass: "t-panel-list"
    }, _vm._l(al.attachments, function (a, ai) {
      return _c('li', {
        key: ai,
        staticClass: "t-panel-item"
      }, [_c('a', {
        staticClass: "t-attachment",
        attrs: {
          "href": a.href,
          "target": a.target,
          "rel": a.rel
        }
      }, [_vm._v(" " + _vm._s(a.name) + " ")])]);
    }), 0)]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }